import { z } from 'zod';

export const establishmentDisableSchema = z.object({
  disable_reason: z.string({ message: 'Campo obrigatório' }).min(1, { message: 'Campo obrigatório' }),
});

export type EstablishmentDisableValidationSchema = z.infer<typeof establishmentDisableSchema>;

export const establishmentEnableSchema = z.object({
  enable_reason: z.string({ message: 'Campo obrigatório' }).min(1, { message: 'Campo obrigatório' }),
});

export type EstablishmentEnableValidationSchema = z.infer<typeof establishmentEnableSchema>;
